import "./widgets-core11.css";
import { defineComponent as i, computed as r, openBlock as a, createElementBlock as n, normalizeClass as c, unref as p, createVNode as d, Transition as l, withCtx as u, renderSlot as m } from "vue";
import { u as f } from "./chunks/useDevicePosition.CNFcvGt1.js";
import { _ } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
const v = /* @__PURE__ */ i({
  __name: "FloatingBox",
  props: {
    position: {}
  },
  setup(t) {
    const e = f(t.position), o = r(() => {
      switch (e.value) {
        case "UL":
        case "UR":
          return "slide-down";
        case "CL":
          return "slide-right";
        case "CR":
          return "slide-left";
        default:
          return "slide-up";
      }
    });
    return (s, w) => (a(), n("div", {
      class: c([
        "widget",
        `widget--${p(e)}`
      ]),
      "data-testid": "widget"
    }, [
      d(l, {
        name: o.value,
        appear: ""
      }, {
        default: u(() => [
          m(s.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["name"])
    ], 2));
  }
}), k = /* @__PURE__ */ _(v, [["__scopeId", "data-v-6ec2e81b"]]);
export {
  k as default
};
//# sourceMappingURL=widgets-core.es13.js.map
